# Emulates the TinyMCE 5 `fullpage` plugin, which was removed in TinyMCE 6 (and
# so never existed in its fork HugeRTE). The editor only ever edits the <body>
# of a document, but a lot of
# GreenArrow content (campaign HTML, the subscriber-quota notification email, the
# terms-of-service HTML) is a *full* document whose doctype, <html> attributes and
# <head> must survive a round-trip through the editor.
#
# On the way in we peel off the document shell around the body and remember it; on
# the way out we restore it (wrapping a bare fragment into a full document, just as
# fullpage did). This plugin is added only to the config/hugerte.yml presets that
# previously listed the fullpage plugin (default, subscriber_quota,
# default_with_code) -- notably NOT partial_page, which edits body fragments.
#
# The split/wrap logic lives in helpers/full_document.js and is published on
# window.FullDocument by js/vendor/studio.js.
hugerte.PluginManager.add("fullpageemulation", (editor) ->
  # The document shell captured from the last full setContent, or null when the
  # source was a bare fragment (in which case a default shell is used on output).
  shell = null

  editor.on("BeforeSetContent", (e) ->
    # Only whole-document sets carry the shell; leave inserts and pastes (which
    # drop content at the selection) untouched.
    return if e.selection or e.paste

    split = FullDocument.splitFullDocument(e.content)
    shell = if split.isFullDocument then split else null
    e.content = split.body
  )

  editor.on("GetContent", (e) ->
    # Only re-wrap the HTML serialization of the whole document; leave selection
    # reads and non-HTML formats (e.g. "text") alone.
    return if e.selection
    return unless e.format == "html"

    e.content = FullDocument.wrapFullDocument(shell, e.content)
  )

  editor.options.set("preview_content_callback", FullDocument.fullDocumentBody)
)
